import Breadcrumb from "@/components/feature/Breadcrumb";
import usePageMeta from "@/hooks/usePageMeta";

const STATS = [
  { value: "40+", label: "剧集内容" },
  { value: "30+", label: "电影资源" },
  { value: "1080P", label: "高清画质" },
  { value: "7×24", label: "持续更新" },
];

const VALUES = [
  {
    icon: "ri-compass-3-line",
    title: "以用户找片体验为先",
    desc: "围绕“激情丛林”系列聚合相关内容，通过清晰的分类、精准搜索与相关推荐，让用户少走弯路，快速找到想看的影视作品。",
  },
  {
    icon: "ri-leaf-line",
    title: "坚持合法与正向内容",
    desc: "本站所有影视信息均为前端演示数据，用于展示产品结构与界面。我们不存储、不提供任何侵权影视资源的下载与播放。",
  },
  {
    icon: "ri-speed-up-line",
    title: "持续优化观看体验",
    desc: "不断打磨页面加载速度、播放区域交互与移动端适配，努力让每一次浏览与观看都顺畅、舒适。",
  },
];

const CONTACTS = [
  { icon: "ri-mail-line", label: "意见反馈", value: "support@jingqi-conglin.example" },
  { icon: "ri-team-line", label: "内容合作", value: "partner@jingqi-conglin.example" },
  { icon: "ri-wechat-line", label: "微信公众号", value: "激情丛林影视（示例）" },
  { icon: "ri-weibo-line", label: "官方微博", value: "@激情丛林影视站（示例）" },
];

export default function AboutPage() {
  usePageMeta({
    title: "关于我们 - 激情丛林影视内容站",
    description:
      "了解激情丛林影视内容站的定位、宗旨与服务范围，以及联系方式、版权声明与用户须知，欢迎反馈与内容合作。",
    keywords: "关于激情丛林,激情丛林影视站,联系方式,版权声明",
  });
  return (
    <div className="px-4 md:px-6 py-6 md:py-10">
      <div className="max-w-5xl mx-auto">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />

        <div className="mt-5 mb-10">
          <h1 className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950">
            关于激情丛林
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">
            激情丛林是一个以“激情丛林”电视剧及同类型影视内容为核心的在线观看与介绍平台，
            面向广大影视爱好者，致力于提供简洁、清晰、易用的找片与观影导航体验。
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 mb-10 md:mb-14">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="p-5 bg-background-50 rounded-lg border border-background-200 text-center"
            >
              <p className="font-heading text-2xl md:text-3xl font-extrabold text-primary-600">
                {stat.value}
              </p>
              <p className="mt-1 text-xs md:text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>

        <section className="mb-10 md:mb-14">
          <h2 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950 mb-5 flex items-center gap-2.5">
            <span className="w-1.5 h-6 rounded-full bg-accent-500"></span>
            我们的宗旨
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {VALUES.map((value) => (
              <div key={value.title} className="p-5 md:p-6 bg-background-50 rounded-lg border border-background-200">
                <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-700 mb-4">
                  <i className={`${value.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <h3 className="text-base font-bold text-foreground-950 mb-2">{value.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{value.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-10 md:mb-14">
          <h2 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950 mb-5 flex items-center gap-2.5">
            <span className="w-1.5 h-6 rounded-full bg-primary-500"></span>
            联系方式
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {CONTACTS.map((contact) => (
              <div
                key={contact.label}
                className="flex items-center gap-4 p-5 bg-background-50 rounded-lg border border-background-200"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-900 shrink-0">
                  <i className={`${contact.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="min-w-0">
                  <span className="block text-xs text-foreground-400">{contact.label}</span>
                  <span className="block text-sm font-semibold text-foreground-900 truncate">
                    {contact.value}
                  </span>
                </span>
              </div>
            ))}
          </div>
          <a
            href="mailto:support@jingqi-conglin.example"
            className="mt-6 inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-semibold px-6 py-3 rounded-md cursor-pointer whitespace-nowrap transition-colors"
          >
            <i className="ri-send-plane-line" aria-hidden="true"></i>
            发送反馈邮件
          </a>
        </section>

        <section className="p-6 md:p-8 bg-primary-50 rounded-lg border border-primary-200">
          <h2 className="font-heading text-lg md:text-xl font-extrabold text-foreground-950 mb-4 flex items-center gap-2">
            <i className="ri-copyright-line text-primary-600" aria-hidden="true"></i>
            版权声明与用户须知
          </h2>
          <ul className="space-y-3 text-sm text-foreground-700 leading-relaxed">
            <li className="flex gap-2.5">
              <i className="ri-checkbox-circle-line text-primary-600 mt-0.5 shrink-0" aria-hidden="true"></i>
              本站所有影视名称、海报、剧情与演职人员信息均为前端演示数据，仅用于展示产品结构与界面效果。
            </li>
            <li className="flex gap-2.5">
              <i className="ri-checkbox-circle-line text-primary-600 mt-0.5 shrink-0" aria-hidden="true"></i>
              本站不存储、不制作、不上传任何影视资源，播放区域为界面演示，不提供真实音视频内容。
            </li>
            <li className="flex gap-2.5">
              <i className="ri-checkbox-circle-line text-primary-600 mt-0.5 shrink-0" aria-hidden="true"></i>
              请勿将本站内容用于任何商业用途，实际影视版权请以官方发布渠道为准。
            </li>
            <li className="flex gap-2.5">
              <i className="ri-checkbox-circle-line text-primary-600 mt-0.5 shrink-0" aria-hidden="true"></i>
              如对内容有任何建议或版权疑问，欢迎通过上方邮箱与我们联系，我们将及时处理。
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
}